import { render, staticRenderFns } from "./appField.vue?vue&type=template&id=21d0a232&scoped=true&"
import script from "./appField.vue?vue&type=script&lang=js&"
export * from "./appField.vue?vue&type=script&lang=js&"
import style0 from "./appField.vue?vue&type=style&index=0&id=21d0a232&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d0a232",
  null
  
)

export default component.exports